import { Typography } from '@material-ui/core'
import React from 'react'

import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import { makeStyles } from '@material-ui/core'
const useStyles = makeStyles((theme) => ({
  select: {
    backgroundColor: 'none',
  },
}))
// import { colourOptions } from '../data'

const animatedComponents = makeAnimated()

export default function MultiSelectInput({
  value,
  options,
  form,
  setForm,
  name,
  label,
  handleChange,
  fieldValue,
  fieldLabel,
  disabled,
  fieldLabel2,
}) {
  const customStyles = {
    control: () => ({
      backgroundColor: 'none',
      alignItems: 'center',
      minHeight: '38px',
      position: 'relative',
      outline: '0!important',
      transition: 'all 100ms',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      cursor: 'pointer',
      border: 'none',
      display: 'flex',
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'

      return { ...provided, opacity, transition }
    },
  }
  const handleFormChange = (e) => {
    setForm({ ...form, [name]: Array.isArray(e) ? e.map((x) => x.value) : [] })
  }
  const handleChangeNew = (e) => {
    handleChange(Array.isArray(e) ? e.map((x) => ({ _id: x.value, name: x.label })) : [])
  }
  let tempOptions =
    fieldValue && fieldLabel
      ? options &&
        options.map((item) => {
          return {
            label: fieldLabel2 ? `${item[fieldLabel]}/${item[fieldLabel2]}` : item[fieldLabel],
            value: item[fieldValue],
          }
        })
      : options &&
        options.map((item) => {
          return { label: item, value: item }
        })

  // options should be array of object with key as label and value

  return (
    <>
      <Typography style={{ fontWeight: 600, fontSize: '14px', marginTop: '15px' }}>{label}</Typography>
      <Select
        closeMenuOnSelect={false}
        components={animatedComponents}
        value={value}
        isMulti
        isDisabled={disabled}
        options={tempOptions}
        // value={value}
        onChange={handleChange ? handleChangeNew : handleFormChange}
        styles={customStyles}
        // style={{ marginTop: '30px' }}
        placeholder={''}
        name={name}
      />
    </>
  )
}
